module.exports = __webpack_public_path__ + "images/browser-icons-24px.png?6cc17b875f991209c7a4883ff35dc6a0";